import 'alpinejs/dist/alpine-ie11';
import axios from 'axios';
import AlpineModules from './modules/alpine';
import { track as mixpanelTrack, MixpanelEvent } from './mixpanel';

require('./sentry');

AlpineModules.init();

// GWB-411: works:viewed on the public job list. The payload is injected only
// by LandingController::getFullJobsList (gated on MIXPANEL_EVENTS), so this
// no-ops on every other tailwind.js page. track() returns false until the SDK
// has consent + config, so the initial call is a no-op pre-consent; the single
// CookiebotOnConsentReady listener is the one later chance to fire (mixpanel.js's
// own init listener registered first — import order — so the client exists by
// then). Plain fired-flag instead of {once:true} — IE11 bundle.
let guestWorksViewedFired = false;
function fireGuestWorksViewed() {
    const props = window.gwbSrv && window.gwbSrv.worksViewedGuest;
    if (!props || guestWorksViewedFired) {
        return;
    }
    guestWorksViewedFired = mixpanelTrack(MixpanelEvent.WORKS_VIEWED, props);
}
fireGuestWorksViewed();
window.addEventListener('CookiebotOnConsentReady', fireGuestWorksViewed);

/**
 * Axios HTTP library available as global
 */
axios.defaults.headers.common = {
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
    'X-Requested-With': 'XMLHttpRequest', // So Laravel recognises ajax request
    Accept: 'application/json',
};

window.axios = axios;

// IE11 polyfill for object-fit
if ('objectFit' in document.documentElement.style === false) {
    document.addEventListener('DOMContentLoaded', () => {
        Array.prototype.forEach.call(document.querySelectorAll('img.object-contain'), (image) => {
            /* eslint-disable no-param-reassign, max-len */
            (image.runtimeStyle || image.style).background = `url("${image.src}") no-repeat 50%/${image.currentStyle ? image.currentStyle['object-fit'] : 'contain'}`;
            image.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${image.width}' height='${image.height}'%3E%3C/svg%3E`;
            /* eslint-enable no-param-reassign, max-len */
        });
    });
}
